import { Stack, Typography } from '@mui/material';

// Components
import { IContributeDetailCompany } from 'src/utils/typings/response/contribute';
import { renderTextOrDefault } from 'src/utils/helpers/stringHelpers';
import ListImages from 'src/components/common/ListImages';
import { getArrayDefault } from 'src/utils/helpers/arrayHelpers';

const ClaimCompanyInfor = ({ dataContribution }: { dataContribution: IContributeDetailCompany }) => {
  const photos = getArrayDefault(dataContribution?.contribution_claim_your_company_profile?.images).map((img) => ({
    url: img?.url || '',
  }));
  return (
    <Stack spacing={2} flex={1}>
      <Stack spacing={1}>
        <Typography align="left" variant="caption2" color="text.secondary">
          Company Name
        </Typography>
        <Typography align="left" variant="body2" color="text.primary">
          {renderTextOrDefault(dataContribution?.contribution_claim_your_company_profile?.company_email || '')}
        </Typography>
      </Stack>
      <Typography align="left" variant="subtitle1" color="text.main">
        A Few Pictures For Authentication
      </Typography>
      <ListImages listImg={photos} showBtnAddMoreImg={false} widthImg={80} limit={photos.length} />
    </Stack>
  );
};

export default ClaimCompanyInfor;
